<template>
    <div id="back" class="word" @click="backFn">
        <img class="back-img" src="@/assets/images/back.png" alt="" >
        {{$t('header.returns')}}
    </div>
</template>

<script>
export default {
    methods:{
        backFn(){
           this.$router.go(-1)
        }
    }
}
</script>
<style scoped>
    #back{
        display:flex;
        font-size: 16px;
        color: #666;
        align-items: center;
        height: 65px;
        cursor: pointer;
    }
    .back-img{
        width: 14px;
        height: 14px;
        margin-right:5px ;
    }
</style>



// WEBPACK FOOTER //
// src/components/assembly/Back.vue